export default "__VITE_ASSET__Cd_KJmvY__"